
import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = "https://onlinepk.me/admin/api";

export default function Home({
  banners = [],
  slide = 0,
  filteredProducts = [],
  addToCart = () => {},
  setPage = () => {},
  language = "en",
}) {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const isUrdu =
    language?.toLowerCase() === "ur" ||
    language?.toLowerCase() === "urdu";
useEffect(() => {
  const loadProducts = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${API_BASE}/products`);

      console.log("API Response:", res.data);

      let productData = [];

      if (Array.isArray(res.data)) {
        productData = res.data;
      } else if (Array.isArray(res.data.data)) {
        productData = res.data.data;
      } else if (Array.isArray(res.data.products)) {
        productData = res.data.products;
      }

      setProducts(productData);

    } catch (error) {
      console.error("Products Error:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  loadProducts();
}, []);
  const text = {

    en: {
      title: "New ARRIVAL",
      desc: "Upgrade your cart with fresh finds!",
      btn: "Shop Now",
      flash: "Flash Sale",
      addToCart: "Add To Cart",
    },

    ur: {
      title: "نئی آمد",
      desc: "تازہ تلاشوں کے ساتھ اپنی ٹوکری کو اپ گریڈ کریں!",
      btn: "ابھی خریداری کریں",
      flash: "فلیش سیل",
      addToCart: "کارٹ میں شامل کریں",
    },

  };


  const currentText = text[language] || text.en;


  const heroImage =
    banners.length > 0
      ? banners[slide]
      : "/no-image.png";



  return (

    <>


      {/* Hero Section */}

      <section
        className="hero"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >


        <div className="hero-text">


          <h1 onClick={() => setPage("new-arrival")}>

            {currentText.title}

          </h1>



          <p onClick={() => setPage("upgrade")}>

            {currentText.desc}

          </p>



          <button onClick={() => setPage("shop")}>

            {currentText.btn}

          </button>


        </div>


      </section>





      {/* Flash Sale */}

      <div className="products-container">

      <h2 className="products-title">
        {isUrdu ? "تمام مصنوعات" : "Flash Sale"}
      </h2>

      <div className="products-grid">
{products.length > 0 ? (
  products.map((product) => (
    <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={product.id}>
      <div className="card h-100 shadow-sm">

        <img
  src={
    product.img
      ? `https://onlinepk.me/admin/upload/item/${product.img}`
      : "/no-image.png"
  }
  alt={product.name}
  className="card-img-top"
  style={{ height: "220px", objectFit: "cover" }}
  onError={(e) => {
    e.target.src = "/no-image.png";
  }}
/>

        <div className="card-body">
          <h5 className="card-title">{product.name}</h5>

          {/* <p className="card-text">
            {product.description}
          </p> */}

          <p>
            <strong>MRP:</strong> Rs. {product.mrp}
          </p>

          <p>
            <strong>Small Price:</strong> Rs. {product.smallPrice}
          </p>

          <p>
            <strong>Medium Price:</strong> Rs. {product.mediumPrice}
          </p>

          <p>
            <strong>Large Price:</strong> Rs. {product.largePrice}
          </p>

        <button
             className="add-btn"
              onClick={() => addToCart(product)}
           >
             {isUrdu
               ? "کارٹ میں شامل کریں"
                              : "Add To Cart"}
                              </button>
        </div>

      </div>
    </div>
  ))
) : (
  <div className="col-12 text-center">
    <h3>No Products Found</h3>
  </div>
)}
      </div>

    </div>


    </>

  );

}